// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__xxk6g","content":"RecentSearches_content__38fX-"};